import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CategoriaService } from '../../services/categoria.service';
import { Categoria } from '../../model/categoria';
import { Tipo } from '../../model/tipo';
import { UtilitiesService } from '../../services/utilities.service';
import { TipoService } from '../../services/tipo.service';

@Component({
  selector: 'app-categoria-articulo-mantenimiento',
  templateUrl: './categoria-articulo-mantenimiento.component.html',
  styleUrls: ['./categoria-articulo-mantenimiento.component.css']
})

export class CategoriaArticuloMantenimientoComponent implements OnInit {

  @Input() categoriaSeleccionada: Categoria;
  @Input() codigoConsorcio: string;
  @Output() onReturn = new EventEmitter();
  @Output() onItemSelected = new EventEmitter();

  public categoria: Categoria = new Categoria();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;
  public tipos: Tipo[];

  public ENTRADA: boolean;
  public SALIDA: boolean;
  public ALMACENAMIENTO: boolean;
  public MOVIMIENTO: boolean;
  public CARGA: boolean;
  public DESCARGA: boolean;
  public ALISTO: boolean;
  public SEGURO: boolean;

  public valor: string;

  public errorMessage: any;

  public div_array:any;


  constructor(
    private _categoriaService: CategoriaService,
    private _tipoService: TipoService
  ) { }


  ngOnInit() {

    this.div_array = ["ENTRADA","SALIDA","ALMACENAMIENTO","MOVIMIENTO","CARGA","DESCARGA","ALISTO","SEGURO"];
    this.toggle_div("ENTRADA");
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    if (this.categoriaSeleccionada != null) {
      this.categoria = this.categoriaSeleccionada;
      this.estadoEditar = true;
    }
    this.getTipos();
  }

  toggle_div(param){      
    for(let i = 0; i < this.div_array.length; i++){
           this[this.div_array[i]] = false;
              if(this.div_array[i] === param){
                 this[this.div_array[i]] = true; 
              }         
    }
  }


  onSubmit() {
    if (this.categoria.id === undefined) {
      this.categoria.id = 0;
    }

    this.categoria.codigoConsorcio = this.codigoConsorcio;

    this._categoriaService.insert(this.categoria).subscribe(
      result => { 
        if(result.Resultado === "codigoCategoria ya existe en la base de datos"){
            alert("El código de la Categoría ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.log(err);
      });
  }



  getTipos() {
    this._tipoService.getTipos()
      .subscribe(
      data => {
        this.tipos = data.filter(a => a.tipo === "ALMACENAJE");
      },
      err => {
        console.log(err);
      });
  }

  Select_Event(valor: string, tipo: string) {
    this.categoria[tipo + "Tipo"] = valor;
  }

  Select_Event_Formula(valor: string, tipo: string) {   
    this.categoria["idFormula"+tipo.charAt(0).toUpperCase() + tipo.slice(1).toLowerCase()] = valor;
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }


  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._categoriaService.delete(this.categoria).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });
  }


}




// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/categoria-articulo-mantenimiento/categoria-articulo-mantenimiento.component.ts